export default {
  en: {
    title: 'Buy now. Pay with Klarna at your own pace.',
    subTitle: 'Get what you love, choose how you pay.',
    timelineHeader: 'How it works',
    timelineItems: [
      {
        title: 'At checkout select Klarna',
        description: ''
      },
      {
        title: 'Choose your payment plan',
        description: 'Different payment plans may be shown depending on the purchase amount and credit score.'
      },
      {
        title: 'Complete your checkout',
        description: 'The amount will be charged based on the payment plan you chose.'
      }
    ]
  },
  es: {
    title: 'Compra ahora. Paga con Klarna a tu propio ritmo.',
    subTitle: 'Get what you love, choose how you pay.',
    timelineHeader: 'Cómo funciona?',
    timelineItems: [
      {
        title: 'En el momento del pago, elige Klarna',
        description: ''
      },
      {
        title: 'Selecciona un plan de pago',
        description: 'Pueden mostrarse distintos planes de pago en función del importe de la compra y de tu ratio de solvencia.'
      },
      {
        title: 'Completa el pedido',
        description: 'El importe se cobrará en función del plan de pago que hayas elegido.'
      }
    ]
  }
}
